import * as ActionTypes from "./../ActionTypes";

export const POSTS = (posts = [], action) => {
    switch (action.type) {
        case ActionTypes.FETCH_POSTS:
            return action.payload;

        case ActionTypes.NEW_POST:
            return [action.payload, ...posts];

        case ActionTypes.DELETE_POST:
            return posts.filter(post => post._id !== action.payload);

        case ActionTypes.LIKE_POST:
        case ActionTypes.UPDATE_POST:
            return posts.map(post => post._id === action.payload._id ? action.payload : post);

        case ActionTypes.NEW_COMMENT:
        case ActionTypes.DEL_COMMENT:
            return posts.map(post => post._id === action.payload._id ? action.payload : post);

        default:
            return posts;
    }
}